// event.schema.json source — one JSONL record in `journal.jsonl` (spec §3.4
// "Transaction và ghi bền"): "Mỗi record là một JSON UTF-8 kết thúc bằng
// newline, chứa seq tăng liên tục, event_id, operation_id, expected
// revision, toàn bộ delta và event_checksum." Checksum is SHA-256 over the
// canonical representation of the event MINUS the checksum field itself
// (spec: "loại trường checksum").
import { z } from "zod";

export const EventSchema = z
  .object({
    schema_version: z.literal(1),
    seq: z.number().int().nonnegative(),
    event_id: z.string().min(1),
    operation_id: z.string().min(1),
    mission_id: z.string().min(1),
    // Expected revision this event was produced against — optimistic
    // concurrency guard for mission/ticket projections.
    expected_revision: z.number().int().nonnegative(),
    event_type: z.string().min(1),
    // Full delta payload — event-type specific, validated by the reducer,
    // not by this envelope schema (same "no hardcoded business logic in
    // schema" boundary as directive.schema.json).
    delta: z.record(z.string(), z.unknown()),
    recorded_at: z.string().min(1),
    event_checksum: z.string().regex(/^[0-9a-f]{64}$/i),
  })
  .strict();

export type Event = z.infer<typeof EventSchema>;
